import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import React, { useEffect, useState, useRef, useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import io from 'socket.io-client';
import PermisoDenegado from '../../components/PermisoDenegado';
import Loader from '../../components/Loader';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BASE_URL, { IMAGE_DOMAIN } from '../../config/config';
import Verificacion from '../../components/Verificacion';
import Suspendido from '../../components/Suspendido';

const Ticket = () => {
    const { identificador } = useParams();
    const [ticket, setTicket] = useState({ chat: [] });
    const [usuarioCreador, setUsuarioCreador] = useState(null);
    const [content, setContent] = useState('');
    const [socket, setSocket] = useState(null);
    const [tecnicos, setTecnicos] = useState([]);
    const [usuarioEscribiendo, setUsuarioEscribiendo] = useState(null);
    const [permisosVerificados, setPermisosVerificados] = useState(false);
    const [permisoDenegado, setPermisoDenegado] = useState(false);
    const [isSending, setIsSending] = useState(false); // Estado para controlar "Enviando..."

    const [selectedFiles, setSelectedFiles] = useState([]); // Estado para los archivos seleccionados
    const [filesToUpload, setFilesToUpload] = useState([]); // Archivos para enviar al backend
    const [showAllFiles, setShowAllFiles] = useState(false);
    const [errorAlEnviar, setErrorAlEnviar] = useState(false);

    const popupRef = useRef(null);


    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        const maxFileSize = 5 * 1024 * 1024; // 5 MB
        const validFiles = [];
        const invalidFiles = [];

        files.forEach((file) => {
            if (file.size <= maxFileSize) {
                validFiles.push(file);
            } else {
                invalidFiles.push({ name: file.name, size: (file.size / (1024 * 1024)).toFixed(2) });
            }
        });

        if (invalidFiles.length > 0) {
            const errorMessage = invalidFiles
                .map((file) => `${file.name} (${file.size} MB)`)
                .join('\n');
            toast.error(
                `Los siguientes archivos exceden el tamaño permitido de 5 MB:\n${errorMessage}`,
                { position: "top-right", autoClose: 7000 }
            );
        }

        setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);
        setFilesToUpload((prevFiles) => [...prevFiles, ...validFiles]);

        console.log('Archivos seleccionados:', validFiles);
        console.log('Archivos rechazados:', invalidFiles);
    };

    const handleRemoveFile = (index) => {
        setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    const chatRef = useRef(null);
    const bottomRef = useRef(null);

    const token = localStorage.getItem("AuthToken");
    let tokenInfo = {};
    if (token) {
        tokenInfo = jwtDecode(token);
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setShowAllFiles(false);
            }
        };

        if (showAllFiles) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showAllFiles]);


    useEffect(() => {
        const verificarPermisos = async () => {
            try {
                const response = await axios.get(`${BASE_URL}/obtener-ticket/${identificador}`);
                const data = response.data;

                if (data.ticket) {
                    data.ticket.chat = Array.isArray(data.ticket.chat) ? data.ticket.chat : JSON.parse(data.ticket.chat);
                    setTicket(data.ticket);

                    if (data.ticket.usuario_creador !== tokenInfo.usuario && tokenInfo.role !== 'admin') {
                        setPermisoDenegado(true);
                    }
                }

                const usuarioResponse = await axios.get(`${BASE_URL}/usuario/info/${data.ticket.usuario_creador}`,
                    { headers: { Authorization: token } }
                );
                setUsuarioCreador(usuarioResponse.data.usuario);
            } catch (error) {
                console.error('Error al obtener el ticket:', error);
            } finally {
                setPermisosVerificados(true);
            }
        };

        verificarPermisos();
    }, [identificador, tokenInfo.usuario, tokenInfo.role]);

    useEffect(() => {
        const fetchTecnicos = async () => {
            try {
                const response = await axios.get(`${BASE_URL}/usuario/tecnicos`);
                setTecnicos(response.data.usuarios);
            } catch (error) {
                console.error('Error al obtener la lista de técnicos:', error);
            }
        };

        fetchTecnicos();
    }, []);

    const scrollToBottom = () => {
        if (chatRef.current) {
            chatRef.current.scrollTop = chatRef.current.scrollHeight;
        }
    };

    const scrollToTop = () => {
        if (chatRef.current) {
            chatRef.current.scrollTop = 0;
        }
    };

    useEffect(() => {
        if (ticket.estado_del_ticket === "cerrado") {
            //scrollToTop();
        } else if (ticket.chat.length > 0) {
            const timeout = setTimeout(() => {
                scrollToBottom();
            }, 100);
            return () => clearTimeout(timeout);
        }
    }, [ticket.chat, ticket.estado_del_ticket]);

    const handleChange = (value) => {
        setContent(value);
        if (socket) {
            socket.emit('escribiendo', {
                identificador: identificador,
                usuario: tokenInfo.usuario,
                nombre: tokenInfo.nombre,
                apellidos: tokenInfo.apellidos,
            });
        }
    };

    const splitFiles = (filesString) => {
        return filesString.split(",");
    };

    const getFileName = (url, length = 10) => {
        const fileName = url.substring(url.lastIndexOf('/') + 1);
        const extensionIndex = fileName.lastIndexOf('.');
        const name = fileName.substring(0, extensionIndex);
        const extension = fileName.substring(extensionIndex);
        const shortenedName = name.length > length ? name.substring(0, length) + '...' : name;
        return shortenedName + extension;
    };

    const getIconUrl = (file) => {
        const extension = file.split('.').pop().toLowerCase();
        switch (extension) {
            case 'png':
            case 'jpg':
            case 'jpeg':
                return '/images/imagen-icono.svg';
            case 'psd':
            case 'gif':
            case 'zip':
            case 'docx':
            case 'doc':
            case 'svg':
            case 'pdf':
            case 'xlsx':
            case 'csv':
                return `/images/${extension}.svg`;
            default:
                return '/images/almacenamiento-de-archivos.svg';
        }
    };

    const copiarTicket = () => {
        const cleanHTML = (html) => {
            if (!html) return 'No especificada';
            const doc = new DOMParser().parseFromString(String(html), 'text/html');
            return (doc.body.textContent || '').trim();
        };

        const ticketHTML = `
            <b>Ticket ID:</b> <span style="color:#268dc2; font-weight: 600;">#${ticket.identificador}</span><br/>
            <b>Asunto:</b> ${ticket.asunto || 'No especificado'}
            <br/><b>Descripción:</b> ${cleanHTML(ticket.descripcion)}<br/>
            <b>Prioridad:</b> ${ticket.prioridad === 'urgente' ? 'Urgente' : 'No urgente'}<br/>
            <hr/>
            <p style="color:#268dc2; font-weight: 600;">Datos del cliente:</p>
            <b>Nombre:</b> ${ticket.nombre} ${ticket.apellidos}<br/>
            <b>Email:</b> ${ticket.email}<br/>
            <b>Teléfono:</b> ${ticket.telefono}<br/>
            <b>Webs:</b> ${ticket.webs_del_cliente || '—'}<br/>
        `.trim();

        navigator.clipboard.write([
            new ClipboardItem({
                "text/html": new Blob([ticketHTML], { type: "text/html" }),
                "text/plain": new Blob([ticketHTML.replace(/<[^>]*>?/gm, '')], { type: "text/plain" })
            })
        ])
            .then(() => {
                toast.success("Información del ticket copiada.", { position: "bottom-right" });
            })
            .catch(() => {
                toast.error("Error al copiar la información del ticket.", { position: "bottom-right" });
            });
    };



    const actualizarDpto = async (nuevoDpto) => {
        try {
            await axios.put(`${BASE_URL}/actualizar-dpto`, { identificador, dpto: nuevoDpto });
            setTicket((prevTicket) => ({
                ...prevTicket,
                dpto: nuevoDpto,
            }));
        } catch (error) {
            console.error('Error al actualizar el dpto:', error);
        }
    };

    const actualizarPrioridad = async (nuevaPrioridad) => {
        try {
            await axios.put(`${BASE_URL}/actualizar-prioridad`, { identificador, prioridad: nuevaPrioridad });
            setTicket((prevTicket) => ({
                ...prevTicket,
                prioridad: nuevaPrioridad,
            }));
        } catch (error) {
            console.error('Error al actualizar la prioridad:', error);
        }
    };

    const actualizarEstadoDelTicket = async (nuevoEstado) => {
        try {
            await axios.put(`${BASE_URL}/actualizar-estado_del_ticket`, { identificador, estado_del_ticket: nuevoEstado });
            setTicket((prevTicket) => ({
                ...prevTicket,
                estado_del_ticket: nuevoEstado,
            }));

            if (nuevoEstado === 'cerrado' && socket) {
                socket.emit('cerrarTicket', { identificador });
                const notificarCierre = await axios.post(`${BASE_URL}/notificar-cierre-cliente`, {
                    identificador,
                    usuario_creador: ticket.usuario_creador,
                    nombre_cliente: ticket.nombre,
                    asunto: ticket.asunto,
                });
                console.log('Notificación de cierre enviado correctamente:', notificarCierre.data);
            }
        } catch (error) {
            console.error('Error al actualizar el estado del ticket:', error);
        }
    };

    const actualizarTecnicoAsignado = async (usuarioEncargado) => {
        try {
            const response = await axios.put(`${BASE_URL}/actualizar-tecnico`, {
                identificador,
                usuario_encargado: usuarioEncargado
            });

            setTicket((prevTicket) => ({
                ...prevTicket,
                usuario_encargado: usuarioEncargado
            }));

            console.log('Técnico asignado correctamente:', response.data);

            if (usuarioEncargado !== "sin_asignar") {
                const notificarResponse = await axios.post(`${BASE_URL}/notificar-tecnico`, {
                    identificador,
                    usuario_encargado: usuarioEncargado,
                    usuario_notificador: tokenInfo.usuario,
                    usuario_creador: ticket.usuario_creador,
                    nombre_cliente: ticket.nombre,
                    apellidos_cliente: ticket.apellidos,
                    email_cliente: ticket.email,
                    webs_del_cliente: ticket.webs_del_cliente,
                    asunto: ticket.asunto,
                    descripcion: ticket.descripcion
                });

                console.log('Notificación enviada correctamente:', notificarResponse.data);
            } else {
                console.log('Ticket dejado sin asignar, no se envía notificación.');
            }

        } catch (error) {
            console.error('Error al asignar o notificar al técnico del ticket:', error.response ? error.response.data : error.message);
        }
    };



    const obtenerNombreTecnicoAsignado = () => {
        if (ticket.usuario_encargado === 'sin_asignar') return null;
        const tecnico = tecnicos.find(t => t.usuario === ticket.usuario_encargado);
        return tecnico
            ? `${tecnico.nombre} ${tecnico.apellidos} (@${tecnico.usuario})`
            : `@${ticket.usuario_encargado}`;
    };

    const mensajesConDescripcion = useMemo(() => {
        if (!ticket) return [];

        // 1) Mensaje "sintético" con la descripción del ticket
        const primerMensaje = {
            // usa el usuario creador; si aún no llegó usuarioCreador, cae a los campos del ticket
            usuario: ticket.usuario_creador || usuarioCreador?.usuario || 'desconocido',
            nombre: usuarioCreador?.nombre || ticket.nombre || '',
            apellidos: usuarioCreador?.apellidos || ticket.apellidos || '',
            fotoPerfil: usuarioCreador?.fotoPerfil || '/images/usuario.png',
            role: 'user',
            // tu chat usa `texto` como html; la descripción viene en `ticket.descripcion`
            texto: ticket.descripcion || '',
            // usa la fecha de creación del ticket como timestamp del primer mensaje
            fecha: ticket.createdAt || new Date().toISOString(),
            // si quieres adjuntar los archivos iniciales del ticket en ese primer mensaje:
            archivos: ticket.archivos ? ticket.archivos.split(',') : [],
            __esDescripcion: true, // marca interna opcional
        };

        // 2) Resto de mensajes del chat ordenados por fecha ascendente
        const chatOrdenado = (Array.isArray(ticket.chat) ? ticket.chat : []).slice().sort((a, b) => {
            const fa = new Date(a.fecha).getTime();
            const fb = new Date(b.fecha).getTime();
            return fa - fb;
        });

        return [primerMensaje, ...chatOrdenado];
    }, [ticket, usuarioCreador]);


    const enviarMensaje = async () => {
        // Evitamos que se envíe si ya se está procesando un envío
        if (isSending) return;

        if ((!content || content.trim() === "" || content === "<p><br></p>") && filesToUpload.length === 0) {
            setErrorAlEnviar(true);
            return;
        }

        // Activamos el estado "Enviando..."
        setIsSending(true);

        // Si el ticket está cerrado, se reabre automáticamente
        if (ticket.estado_del_ticket === 'cerrado') {
            await actualizarEstadoDelTicket('abierto');
        }

        try {
            let uploadedFiles = [];

            if (filesToUpload.length > 0) {
                const formData = new FormData();
                filesToUpload.forEach(file => formData.append('archivoschat', file));

                const response = await axios.post(`${BASE_URL}/subir-archivos-chat/${ticket.identificador}`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });

                uploadedFiles = response.data.archivosNuevos;
            }

            const mensajeData = {
                identificador: ticket.identificador,
                mensaje: content,
                usuario: tokenInfo.usuario,
                nombre: tokenInfo.nombre,
                apellidos: tokenInfo.apellidos,
                role: tokenInfo.role,
                fotoPerfil: tokenInfo.fotoPerfil,
                archivos: uploadedFiles,
            };

            console.log(uploadedFiles);

            socket.emit('mensaje', mensajeData);

            setErrorAlEnviar(false);
            setContent('');
            setSelectedFiles([]);
            setFilesToUpload([]);
        } catch (error) {
            console.error('Error al enviar el mensaje:', error);
        }



        // Establece un cooldown de 3 segundos antes de permitir otro envío
        setTimeout(() => {
            setIsSending(false);
        }, 3000);
    };

    useEffect(() => {
        const newSocket = io(`${BASE_URL}`);
        setSocket(newSocket);

        newSocket.on('ticketCerrado', (data) => {
            setTicket((prevTicket) => ({
                ...prevTicket,
                estado_del_ticket: 'cerrado'
            }));
        });

        return () => {
            newSocket.disconnect();
        };
    }, []);

    useEffect(() => {
        if (socket && identificador) {
            socket.emit('joinRoom', {
                identificador: identificador,
                usuario: tokenInfo.usuario
            });
        }
    }, [identificador, socket]);

    useEffect(() => {
        if (socket) {
            socket.on('mensaje', (mensaje) => {
                setTicket((prevTicket) => {
                    let nuevoEstadoChat = prevTicket.estado_del_chat;

                    if (mensaje.role === 'user') {
                        nuevoEstadoChat = 'sin_responder';
                    } else if (mensaje.role === 'admin' || mensaje.role === 'tecnico') {
                        nuevoEstadoChat = 'respondido';
                    }

                    // Si el técnico asignado cambia (opcional, solo si lo necesitas)
                    const nuevoUsuarioEncargado = mensaje.usuario_encargado || prevTicket.usuario_encargado;

                    return {
                        ...prevTicket,
                        chat: [...prevTicket.chat, mensaje],
                        estado_del_chat: nuevoEstadoChat,
                        usuario_encargado: nuevoUsuarioEncargado
                    };
                });
            });



            let typingTimeout;
            socket.on('escribiendo', (data) => {
                if (data.usuario !== tokenInfo.usuario) {
                    setUsuarioEscribiendo(`${data.nombre} ${data.apellidos} está escribiendo...`);
                    clearTimeout(typingTimeout);
                    typingTimeout = setTimeout(() => {
                        setUsuarioEscribiendo(null);
                    }, 3000);
                }
            });
        }

        return () => {
            if (socket) {
                socket.off('mensaje');
                socket.off('escribiendo');
            }
        };
    }, [socket]);

    if (!permisosVerificados) {
        return <Loader />;
    }

    if (tokenInfo.estado === 'verificar') return <Verificacion />;
    if (tokenInfo.estado === 'suspendido') return <Suspendido />;

    if (permisoDenegado) {
        return <PermisoDenegado />;
    }

    return (
        <main className='ticket site-width'>
            {ticket && (
                <>
                    <div className='cabecera-ticket'>
                        <div className="cabecera-ticket-uno">
                            <img src="/images/recibo.svg" alt="Icono chat" />
                            <div className="cabecera-ticket-texto">
                                {ticket.estado_del_ticket === 'cerrado' ? (
                                    <>
                                        <h1><span className='marcador-cerrado'></span>Ticket #{ticket.identificador}</h1>
                                        <p>{ticket.asunto}</p>
                                    </>
                                ) : (
                                    <>
                                        <h1><span className={`marcador-abierto ${ticket.estado_del_ticket == 'retenido' ? 'marcador-retenido' : ''}`}></span>Ticket #{ticket.identificador}</h1>
                                        <p>{ticket.asunto}</p>
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="cabecera-ticket-dos">
                            <div className="tecnico-asignado">
                                {ticket.usuario_encargado === "sin_asignar" ? <img src="/images/sin_asignar.svg" alt="Usuario sin asignar" /> : <img src="/images/asignado.svg" alt="Usuario asignado" />}
                                {tokenInfo.role === "admin" || tokenInfo.role === "tecnico" ?
                                    <select
                                        onChange={(e) => actualizarTecnicoAsignado(e.target.value)}
                                        value={ticket.usuario_encargado || "sin_asignar"}
                                    >
                                        <option value="sin_asignar">Sin asignar</option>
                                        {tecnicos.map((tecnico) => (
                                            <option key={tecnico.usuario} value={tecnico.usuario}>
                                                {tecnico.nombre} {tecnico.apellidos} (@{tecnico.usuario})
                                            </option>
                                        ))}
                                    </select> :
                                    <>
                                        <p>
                                            {ticket.usuario_encargado === "sin_asignar"
                                                ? 'Sin asignar'
                                                :
                                                <>
                                                    <b>Técnico asignado:</b><br />
                                                    {obtenerNombreTecnicoAsignado()}

                                                </>

                                            }
                                        </p>
                                    </>
                                }
                            </div>
                            <div className={`estado-del-ticket ${ticket.estado_del_chat === "respondido" ? 'ticket-respondido' : ''}`}>
                                <p>
                                    {ticket.estado_del_chat === "sin_responder" ? 'Esperando respuesta' : ''}
                                    {ticket.estado_del_chat === "respondido" ? 'Respondido' : ''}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="grid-ticket">
                        <div className="datos-ticket">
                            <div className="datos-principales">
                                <div className="mini-descripcion-ticket">
                                    <h3>{ticket.asunto}</h3>
                                    <div className='mini-data'>
                                        <p>#{ticket.identificador}</p>
                                        <p>
                                            {new Date(ticket.createdAt).toLocaleString('es-ES', {
                                                day: '2-digit',
                                                month: 'long',
                                                year: 'numeric',
                                                hour: 'numeric',
                                                minute: '2-digit',
                                                hour12: false
                                            }).replace(',', ' a las')}
                                        </p>
                                    </div>
                                </div>
                                <div className="grid-bloques-datos">
                                    <div className="bloque-datos">
                                        <p>Nombre completo</p>
                                        <p>{ticket.nombre} {ticket.apellidos}</p>
                                    </div>
                                    <div className="bloque-datos">
                                        <p>Email</p>
                                        <p>{ticket.email}</p>
                                    </div>
                                    <div className="bloque-datos">
                                        <p>Teléfono</p>
                                        <p>{ticket.telefono}</p>
                                    </div>
                                    <div className="bloque-datos">
                                        <p>Webs en mantenimiento</p>
                                        <p>{ticket.webs_del_cliente}</p>
                                    </div>
                                </div>
                                <hr />
                                <div className="grid-bloques-gestion">
                                    <h3>Gestión de tu ticket</h3>
                                    <p>Aquí mostramos qué departamento se encarga de tu ticket, qué estado tiene y cuál es su prioridad.</p>
                                    <div className="grid-gestion-datos">
                                        <div className="bloque-datos">
                                            <p>Departamento</p>
                                            {tokenInfo.role === 'admin' ? (
                                                <select value={ticket.dpto} onChange={(e) => actualizarDpto(e.target.value)}>
                                                    <option value="no_especificado">No especificado</option>
                                                    <option value="desarrollo">Desarrollo</option>
                                                    <option value="diseno">Diseño</option>
                                                    <option value="marketing">Marketing</option>
                                                    <option value="redes_sociales">Redes Sociales</option>
                                                </select>
                                            ) : ticket.dpto === 'no_especificado' ? (
                                                <p className='no-especificado'>No especificado</p>
                                            ) : ticket.dpto === 'desarrollo' ? (
                                                <p className="desarrollo">Desarrollo</p>
                                            ) : ticket.dpto === 'diseno' ? (
                                                <p className="diseno">Diseño</p>
                                            ) : ticket.dpto === 'marketing' ? (
                                                <p className="marketing">Marketing</p>
                                            ) : ticket.dpto === 'redes_sociales' ? (
                                                <p className="redes-sociales">Redes Sociales</p>
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                        <div className="bloque-datos color-dato">
                                            <p>Prioridad</p>
                                            {tokenInfo.role === 'admin' ? (
                                                <select value={ticket.prioridad} onChange={(e) => actualizarPrioridad(e.target.value)}>
                                                    <option value="no_urgente">No urgente</option>
                                                    <option value="urgente">Urgente</option>
                                                </select>
                                            ) : ticket.prioridad === 'no_urgente' ? (
                                                <p className='sin-prioridad'>No Urgente</p>
                                            ) : ticket.prioridad === 'urgente' ? (
                                                <p className="alta">Urgente</p>
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                        <div className="bloque-datos">
                                            <p>Estado</p>
                                            {tokenInfo.role === 'admin' ? (
                                                <select value={ticket.estado_del_ticket} onChange={(e) => actualizarEstadoDelTicket(e.target.value)}>
                                                    <option value="abierto">Abierto</option>
                                                    <option value="retenido">Retenido</option>
                                                    <option value="cerrado">Cerrado</option>
                                                </select>
                                            ) : ticket.estado_del_ticket === 'abierto' ? (
                                                <p className="abierto">Abierto</p>
                                            ) : ticket.estado_del_ticket === 'retenido' ? (
                                                <p className="retenido">Retenido</p>
                                            ) : ticket.estado_del_ticket === 'cerrado' ? (
                                                <p className="cerrado">Cerrado</p>
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                    </div>
                                </div>
                                {tokenInfo.role === "admin" && (
                                    <>
                                        <hr />
                                        <div className="acciones-ticket-admin">
                                            <h3>Acciones de administración</h3>
                                            <p>Solo visible para administradores</p>
                                            <button onClick={copiarTicket} className="copiar-ticket">
                                                <img src="/images/copia.svg" alt="Copiar" />
                                                <p>Copiar información del ticket</p>
                                            </button>
                                        </div>
                                    </>

                                )}
                            </div>
                            <div className='datos-archivos'>
                                <p>Archivos aportados</p>
                                {ticket.archivos ? (
                                    <>
                                        <div className='grid-archivos'>
                                            {splitFiles(ticket.archivos)
                                                .slice(0, 3)
                                                .map((file, index) => (
                                                    <a target='_blank' href={file} key={index} className='archivo-ticket' download>
                                                        <img src={getIconUrl(file)} alt={`Archivo ${getFileName(file)}`} />
                                                        <p>{getFileName(file)}</p>
                                                        <img className='descargar' src="/images/descargar.svg" alt="Descargar" />
                                                    </a>
                                                ))}
                                        </div>
                                        {splitFiles(ticket.archivos).length > 3 && (
                                            <button className='ver-todos' onClick={() => setShowAllFiles(true)}>
                                                Ver todos
                                            </button>
                                        )}
                                    </>
                                ) : (
                                    <p className='no-archivos'>No se añadieron archivos</p>
                                )}
                                {showAllFiles && (
                                    <>
                                        <div className="layer-black"></div>
                                        <div className='popup-archivos'>
                                            <div className='popup-contenido' ref={popupRef}>
                                                <button className='cerrar-popup' onClick={() => setShowAllFiles(false)}>x</button>
                                                <h3>Archivos incluídos en el ticket</h3>
                                                <div className='grid-archivos-pop-up'>
                                                    {splitFiles(ticket.archivos).map((file, index) => (
                                                        <a target='_blank' href={file} key={index} className='archivo-ticket' download>
                                                            <img src={getIconUrl(file)} alt={`Archivo ${getFileName(file)}`} />
                                                            <p>{getFileName(file)}</p>
                                                            <img className='descargar' src="/images/descargar.svg" alt="Descargar" />
                                                        </a>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="chat-ticket">
                            <p className='titulo-chat'>Conversación</p>
                            <div className="chat" ref={chatRef}>
                                {mensajesConDescripcion.map((msg, index) => (
                                    <div
                                        key={index}
                                        className={`mensaje-chat ${msg.usuario === tokenInfo.usuario ? 'yo' : ''}`}
                                    >
                                        <img src={msg.fotoPerfil ? (msg.fotoPerfil.startsWith('http') ? msg.fotoPerfil : `${IMAGE_DOMAIN}${msg.fotoPerfil}`) : `${IMAGE_DOMAIN}/images/usuario.png`} alt="Foto de perfil" />
                                        <div className="mensaje-texto">
                                            <p className='mensaje-nombre'>{msg.nombre} {msg.apellidos}</p>
                                            <p className='mensaje-usuario'>@{msg.usuario}</p>
                                            <div className="contenido-mensaje">
                                                <p
                                                    className='mensaje-descripcion'
                                                    dangerouslySetInnerHTML={{ __html: msg.texto }}
                                                />
                                                {msg.archivos && msg.archivos.length > 0 && (
                                                    <div className="mensaje-archivos">
                                                        {msg.archivos.map((file, i) => (
                                                            <a key={i} href={file} target="_blank" rel="noopener noreferrer" className='archivo-adjunto-chat'>
                                                                <img src={getIconUrl(file)} alt="Archivo" />
                                                                <p>{getFileName(file)}</p>
                                                            </a>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                            <p className='mensaje-fecha'>
                                                {new Date(msg.fecha).toLocaleDateString('es-ES', {
                                                    day: '2-digit', month: '2-digit', year: 'numeric'
                                                }) + ' a las ' + new Date(msg.fecha).toLocaleTimeString('es-ES', {
                                                    hour: '2-digit', minute: '2-digit', hour12: false
                                                })}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                                <div className='bottomRef' ref={bottomRef}></div>
                            </div>
                            <div className="enviar-mensaje">
                                {ticket.estado_del_ticket === 'cerrado' && (
                                    <p className="reopen-notice">Este ticket ha sido cerrado. Para reabrirlo, vuelve a enviar un mensaje.</p>
                                )}
                                {usuarioEscribiendo && (
                                    <div className="escribiendo">
                                        <img src="/images/chat-escribiendo.svg" alt="Escribiendo" />
                                        <p>{usuarioEscribiendo}</p>
                                    </div>
                                )}
                                {tokenInfo.role === "admin" &&
                                    ticket.usuario_encargado === "sin_asignar" ? (
                                    <div className='chat-deshabilitado-admin'>
                                        <div className='mensaje-deshabilitado'>
                                            <p>Asigna el ticket a un técnico para habilitar el chat.</p>
                                        </div>
                                        <ReactQuill theme="snow" value={content} onChange={handleChange} />
                                        <button className='enviar-ticket' onClick={enviarMensaje} disabled={isSending}>
                                            {isSending ? "Enviando..." : "Enviar"}
                                        </button>
                                    </div>
                                ) : (
                                    <>
                                        {
                                            tokenInfo.role === "admin" && (
                                                <div className="mensajes-preconfigurados">
                                                    <p>Mensajes preconfigurados</p>
                                                    <div className="mensajes-preconfigurados-lista">
                                                        <button onClick={() => setContent(`¡Hola ${ticket.nombre}!<br/><br/>¿En qué podemos ayudarte?`)}>Mensaje de bienvenida</button>
                                                        <button
                                                            onClick={() =>
                                                                setContent(
                                                                    `¡Hola ${ticket.nombre}!<br/><br/>Hemos recibido tu solicitud y nuestro equipo ya la está revisando en detalle. Te mantendremos al tanto y nos pondremos en contacto contigo a la mayor brevedad por este medio.<br/><br/>Un saludo,<br/>${tokenInfo.nombre}`
                                                                )
                                                            }
                                                        >
                                                            Procesando solicitud
                                                        </button>
                                                        <button
                                                            onClick={() =>
                                                                setContent(
                                                                    `¡Hola de nuevo ${ticket.nombre}!<br/><br/>Acabamos de resolver tu incidencia. ¿Podrías revisar que todo esté correcto? ¡Gracias!<br/><br/>Un saludo,<br/>${tokenInfo.nombre}`
                                                                )
                                                            }
                                                        >
                                                            Incidencia resuelta
                                                        </button>
                                                        <button
                                                            onClick={() =>
                                                                setContent(
                                                                    `¡Hola ${ticket.nombre}!<br/><br/>El asunto de tu ticket corresponde a otro departamento, lo escalamos al departamento correspondiente y el equipo continuará con el seguimiento. ¡Gracias!<br/><br/>Un saludo,<br/>${tokenInfo.nombre}`
                                                                )
                                                            }
                                                        >
                                                            Escala a otro departamento
                                                        </button>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        <div className="gestor-archivo-chat">
                                            {errorAlEnviar && (
                                                <p className='error error-chat'>El mensaje no puede estar vacío</p>
                                            )}
                                            <label className="custum-file-upload" htmlFor="file">
                                                <div className="icon">
                                                    <img src="/images/archive.svg" alt="Adjuntar" />
                                                </div>
                                                <div className="text">
                                                    <span>Adjuntar archivos (máx. 5MB por archivo)</span>
                                                </div>
                                                <input type="file" id="file" multiple onChange={handleFileChange} />
                                            </label>
                                            <div className="file-list-ticket">
                                                {selectedFiles.map((file, index) => (
                                                    <div key={index} className="file">
                                                        <img src="/images/nuevo-documento.svg" alt="Archivo" />
                                                        <p>{file.name}</p>
                                                        <button className="remove-file" onClick={() => handleRemoveFile(index)}>x</button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <ReactQuill theme="snow" value={content} onChange={handleChange} />
                                        <button className={isSending ? "enviar-ticket cooldown" : "enviar-ticket"} onClick={enviarMensaje} disabled={isSending}>
                                            {isSending ? "Enviando..." : "Enviar"}
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </>
            )}
            <ToastContainer position="bottom-right" autoClose={3000} />
        </main>
    );
};

export default Ticket;
